import {z} from '@hono/zod-openapi';

const fastbackB2bDealerSchema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1),
});

export const FastbackB2bDealersResponseSchema = z
  .object({dealers: z.array(fastbackB2bDealerSchema)})
  .openapi('FastbackB2bDealersResponse');
